import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const WashIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"wash"} ref={ref}/>
});

WashIcon.displayName = "WashIcon";
